<template>
  <div class="content">
    <div class="cont_wait">
      <textarea :id="id"></textarea>
    </div>
    <!-- <textarea :id="id" v--if></textarea> -->
  </div>
</template>

<script>
export default {
  name: 'ckeditor4',

  props: ['value', 'content', 'update'],

  created () {},
  mounted: function () {
    // console.log(this.update)
    this.$nextTick(function () {
      const self = this
      // 渲染编辑器
      self.ckeditor = window.CKEDITOR.replace(self.id)
      self.ckeditor.config.uiColor = '#ffffff'
      self.ckeditor.config.allowedContent = true
      self.ckeditor.setData(self.value)
      self.ckeditor.on('change', function () {
        self.$emit('input', self.ckeditor.getData())
        self.$emit('getCkeditor', self.ckeditor)
      })
      self.ckeditor.on('instanceReady', function (ev) {
        self.$emit('getCkeditor', self.ckeditor)
        self.CKEDITOR_4 = ev.editor
        if (self.update !== 0) {
          self.CKEDITOR_4.setReadOnly()
        }
      })
    })
  },
  data: function () {
    return {
      id: parseInt(Math.random() * 10000).toString(),
      ckeditor: null,
      isclose: true,
      CKEDITOR_4: null
    }
  },
  methods: {
    focusEditor (editor) {
      // 获取焦点
      editor.focus()

      // 将光标移至最末
      var range = editor.createRange()
      range.moveToElementEditEnd(editor.editable())

      range.select()
      range.scrollIntoView()
    }
  },
  watch: {
    // 监听prop的变化，更新ckeditor中的值
    value: function () {
      if (this.value !== this.ckeditor.getData()) {
        this.ckeditor.setData(this.value)
      }
    },
    update: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal !== 0) {
          if (this.CKEDITOR_4 !== null) {
            this.CKEDITOR_4.setReadOnly()
          }
        } else {
          if (this.CKEDITOR_4 !== null) {
            this.CKEDITOR_4.setReadOnly(false)
          }
        }
      }
    }
  }
  // 销毁组件前，销毁编辑器
}
</script>
<style lang="less" scoped>
/deep/ #cke_1_top {
  background-color: #f5f7fa !important;
}

.content {
  position: relative;
}
</style>
